export default {
    Chat: "Chat",
    FileSend: "Gönder",
    TypeMessage: "Bir mesaj yazın...",

    ERROR_FILE_TOO_MANY: "Dosya limiti aşıldı!",
}